/**
 * Composant de route protégée SIMPLIFIÉ - Version sans bugs
 * Logique ultra-simple pour éviter les redirections intempestives
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuthSimple.jsx';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Affichage de chargement pendant l'initialisation
  if (loading) {
    // logger.debug('⏳ ProtectedRoute: Chargement en cours...');
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  // Redirection simple si non authentifié
  if (!isAuthenticated) {
    // logger.debug('🚫 ProtectedRoute: Non authentifié, redirection vers login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Affichage du contenu si authentifié
  // logger.debug('✅ ProtectedRoute: Authentifié, affichage du contenu');
  return children;
};

export default ProtectedRoute;
